export default __webpack_public_path__ + "locales/en/EmbeddingPanel.json?hash=f821af0e719a59c463a8a67a19068e2d";